import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { AppState } from '../app.state';

import { NoteState } from './note.state';

export namespace NoteSelectors {
  export const note = (state: AppState): NoteState => state.note;

  export function getState(): MemoizedSelector<AppState, NoteState, DefaultProjectorFn<NoteState>> {
    return createSelector(note, (state: NoteState) => state);
  }

  export function getNote(): MemoizedSelector<AppState, string, DefaultProjectorFn<string>> {
    return createSelector(note, (state: NoteState) => state.note);
  }
}
